import React from 'react';
import { toast, ToastContainer, ToastOptions } from 'react-toastify';
import { useMediaQuery } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';

// Minimal CSS for mobile responsiveness only
const toastStyles = `
  /* Mobile-specific styles */
  @media (max-width: 600px) {
    .Toastify__toast-container {
      width: 100%;
      max-width: 100%;
      padding: 0 16px;
    }
    
    .Toastify__toast {
      width: 100%;
      max-width: 100%;
      margin: 8px 0;
      border-radius: 8px;
    }
  }
  
  /* Tablet styles */
  @media (min-width: 601px) and (max-width: 1024px) {
    .Toastify__toast-container {
      width: 400px;
      max-width: 90vw;
    }
  }
  
  /* Desktop styles */
  @media (min-width: 1025px) {
    .Toastify__toast-container {
      width: 400px;
    }
  }
`;

// Custom hook for responsive toast options
export const useResponsiveToast = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  const getDefaultOptions = (): ToastOptions => ({
    position: isMobile ? "top-center" : "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 60,
  });

  const success = (message: string, options?: Partial<ToastOptions>) => {
    toast.success(message, { ...getDefaultOptions(), ...options });
  };

  const error = (message: string, options?: Partial<ToastOptions>) => {
    toast.error(message, { ...getDefaultOptions(), ...options });
  };

  const warning = (message: string, options?: Partial<ToastOptions>) => {
    toast.warning(message, { ...getDefaultOptions(), ...options });
  };

  const info = (message: string, options?: Partial<ToastOptions>) => {
    toast.info(message, { ...getDefaultOptions(), ...options });
  };

  return { success, error, warning, info };
};

// Responsive ToastContainer component
export const ResponsiveToastContainer: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <>
      <style>{toastStyles}</style>
      <ToastContainer
        position={isMobile ? "top-center" : "top-right"}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
        style={{
          zIndex: 9999,
        }}
      />
    </>
  );
};

export default useResponsiveToast; 